<template>
  <div :class="$options.name">
    <v-card :loading="isLoading" width="800px">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            label="Название"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="ml-2 mr-2">
        <slot name="action-buttons" />
        <div class="flex-grow-1" />
        <v-btn
          v-permission="['role-create', 'role-edit']"
          color="primary lighten-1"
          text
          @click="onCreate"
        >
          Создать
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'application-tokens-create-view',
  asyncData({ store }) {
    const actions = [
      store.dispatch('roles/getFullList'),
      store.dispatch('permissions/getFullList'),
      store.dispatch('layer-objects/getFullList'),
    ];

    return Promise.all(actions);
  },
  data: () => ({
    name: null,
    isLoading: false,
  }),
  methods: {
    ...mapActions('applicationTokens', ['create']),
    ...mapActions(['showNotify']),

    async onCreate() {
      this.isLoading = true;
      this.create({ name: this.name })
        .then(() => {
          this.showNotify({ message: 'Токен успешно создан' });
          this.$router.push({ name: 'application-tokens' });
        })
        .catch(error => {
          this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
